<script>
import Swal from "sweetalert2";
import axios from "axios";

export default {
  emits: ["refreshTable"],
  methods: {
    downloadTemplate() {
      let url =
        process.env.VUE_APP_BACKEND_URL_VERSION + "download-template/diklat";
      window.open(url, "_blank");
    },
    submitForm() {
      const fileInput = this.$refs.fileInput;
      const file = fileInput.files[0];

      if (!file) {
        return;
      }

      Swal.fire({
        title: "Sedang memproses data...",
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        },
      });

      const formData = new FormData();
      formData.append("file", file);

      axios
        .post(
          process.env.VUE_APP_BACKEND_URL_VERSION +
            "verifikasi/diklat/import-excel",
          formData,
          {
            headers: {
              Accept: "application/json",
              Authorization: "Bearer " + localStorage.access_token,
              "Content-Type": "multipart/form-data",
            },
          },
        )
        .then((response) => {
          if (response.data.meta.code == 200) {
            Swal.fire({
              icon: "success",
              title: "Berhasil",
              text: response.data.meta.message,
            });
            fileInput.value = "";
            this.$emit("refreshTable");
          } else {
            this.showImportError(response.data);
          }
        })
        .catch((error) => {
          this.showImportError(error.response?.data);
        });
    },
    showImportError(data) {
      const escapeHtml = (str) =>
        String(str)
          .replace(/&/g, "&amp;")
          .replace(/</g, "&lt;")
          .replace(/>/g, "&gt;")
          .replace(/"/g, "&quot;")
          .replace(/'/g, "&#39;");

      const message = data?.meta?.message || "Terjadi kesalahan";
      const details = Array.isArray(data?.data) ? data.data : [];

      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: details.length ? undefined : message,
        html: details.length
          ? `<div class="text-start">
              <p>${escapeHtml(message)}</p>
              <ul class="mb-0 ps-3">
                ${details.map((item) => `<li>${escapeHtml(item)}</li>`).join("")}
              </ul>
            </div>`
          : undefined,
      });
    },
  },
};
</script>
<template>
  <div class="row">
    <div class="col-12 mb-2">
      <button
        type="button"
        class="btn btn-success btn-sm"
        @click="downloadTemplate()"
      >
        <i class="fa fa-download me-1"></i> Download Template
      </button>
    </div>
    <form @submit.prevent="submitForm">
      <div class="col-12 mb-3">
        <label for="file" class="form-label">Pilih File</label>
        <input
          type="file"
          ref="fileInput"
          class="form-control"
          accept=".xls, .xlsx, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
          required
        />
      </div>

      <div class="text-end mt-4">
        <button type="submit" class="btn btn-success">Import</button>
      </div>
    </form>
  </div>
</template>
